// fill in both in order to get proper intellisense
export type BaseDict = {
    NextRaces: string
    ViewNextCoupons: string
    ViewAll: string
    Left: string
    Right: string
    StartingPrice: string
    NonRunner: string
}
export const BaseDict: BaseDict = {
    NextRaces: "Next {0} Races",
    ViewNextCoupons: " View next {0} coupons",
    ViewAll: "View all",
    Left: "Left",
    Right: "Right",
    StartingPrice: "SP",
    NonRunner: "NR"
}